import { Language } from '@ha/intl';

export const PrivateLandlordPageCountrySlugMap = {
  IT: {
    [Language.en]: 'renting-out-private--Italy',
    [Language.it]: 'affitto-da-privati--Italia',
    [Language.es]: 'alquiler-privado--Italia',
    [Language.fr]: 'location-privée--Italie',
    [Language.de]: 'particulier-verhuren--Italien',
  },
};

export const getPrivateLandlordPageRoutes = () =>
  Object.values(PrivateLandlordPageCountrySlugMap).flatMap(
    localeSlugMap => Object.values(localeSlugMap) as string[],
  );

export const routesWithFreePricingPlan = [
  ...Object.values(PrivateLandlordPageCountrySlugMap.IT),
];
